// extracted by mini-css-extract-plugin
export default {"productFeatured":"Jea-z","carousel":"Kea-z","slides":"Lea-z","slide":"Mea-z","slideFeatured":"Nea-z","zoomMode":"Oea-z","fadeIn":"Pea-z","imageSizing":"Qea-z"};